import { createClient } from "@supabase/supabase-js";

/** @see https://supabase.com/docs/guides/cli/local-development — clé anon par défaut du stack local */
const LOCAL_FALLBACK_URL = "http://127.0.0.1:54321";
const LOCAL_FALLBACK_ANON_KEY =
  "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZS1kZW1vIiwicm9sZSI6ImFub24iLCJleHAiOjE5ODM4MTI5OTZ9.CRXP1A7WOeoJeXxjNni43kdQwgnWNReilDMblYTn_I0";

function resolveSupabaseEnv() {
  const url = process.env.REACT_APP_SUPABASE_URL?.trim();
  const key = process.env.REACT_APP_SUPABASE_ANON_KEY?.trim();
  const urlOk = Boolean(url && /^https?:\/\//i.test(url));
  const keyOk = Boolean(key);
  if (urlOk && keyOk) return { url, key, fromEnv: true };

  if (typeof window !== "undefined") {
    const host = window.location.hostname;
    const isLocalDev = host === "localhost" || host === "127.0.0.1";
    if (!isLocalDev) {
      // eslint-disable-next-line no-console
      console.error(
        "[RdvMarket] REACT_APP_SUPABASE_URL / REACT_APP_SUPABASE_ANON_KEY absents ou invalides au build. " +
          "Définissez-les sur Vercel puis redéployez le frontend (sinon la marketplace reste bloquée)."
      );
      return {
        url: "https://config-manquante.invalid",
        key: "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.e30.invalid",
        fromEnv: false,
      };
    }
    // eslint-disable-next-line no-console
    console.warn(
      "[RdvMarket] REACT_APP_SUPABASE_URL et/ou REACT_APP_SUPABASE_ANON_KEY manquent. Repli local 127.0.0.1:54321 (CLI Supabase)."
    );
  }
  return { url: LOCAL_FALLBACK_URL, key: LOCAL_FALLBACK_ANON_KEY, fromEnv: false };
}

const { url: supabaseUrl, key: supabaseAnonKey } = resolveSupabaseEnv();

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true,
  },
});
